import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const AnnotationBatchDeleteDialog = ({ open, count, onConfirm, onCancel }) => {
  const singular = count === 1;
  return (
    <Dialog
      open={Boolean(open)}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      aria-labelledby="annotation-delete-dialog-title"
      PaperProps={{ sx: { borderRadius: '14px', mx: 2, overflow: 'hidden' } }}
    >
      <DialogTitle id="annotation-delete-dialog-title" sx={{ px: { xs: 2.5, sm: 3 }, pt: 2.5, pb: 1.25 }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
          <DeleteOutlineIcon sx={{ fontSize: 28, mt: '1px', color: '#c62828' }} />
          <Box>
            <Typography component="div" sx={{ fontSize: 18, fontWeight: 700, lineHeight: 1.35 }}>
              Delete Annotation Blocks
            </Typography>
            <Typography component="div" sx={{ fontSize: 18, fontWeight: 700, lineHeight: 1.35, color: '#3f4248', mt: 0.25 }}>
              删除标注方块
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ px: { xs: 2.5, sm: 3 }, pt: '4px !important', pb: 1 }}>
        <Typography sx={{ color: '#30343a', fontSize: 17, lineHeight: 1.5 }}>
          {singular
            ? 'Are you sure you want to delete this annotation block?'
            : `Are you sure you want to delete all ${count} selected annotation blocks?`}
        </Typography>
        <Typography sx={{ color: '#30343a', fontSize: 17, lineHeight: 1.5, mt: 1 }}>
          {singular
            ? '确定要删除这个标注方块吗？'
            : `确定要删除选中的 ${count} 个标注方块吗？`}
        </Typography>
        <Typography sx={{ color: '#666b73', fontSize: 15, lineHeight: 1.45, mt: 1.25 }}>
          This action cannot be undone. 此操作无法撤销。
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: { xs: 2.5, sm: 3 }, pb: 2.25, pt: 1.5, gap: 0.75 }}>
        <Button disableRipple onClick={onCancel} sx={{ color: '#343941', fontWeight: 700, textTransform: 'none' }}>
          Cancel (取消)
        </Button>
        <Button
          disableRipple
          variant="contained"
          color="error"
          onClick={onConfirm}
          sx={{ minWidth: 118, borderRadius: '8px', fontWeight: 700, textTransform: 'none' }}
        >
          Delete (删除)
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AnnotationBatchDeleteDialog;
